import React from "react";

const HeaderTitleContext = React.createContext("Zoning Info");

export const HeaderTitleProvider = HeaderTitleContext.Provider;
export default HeaderTitleContext;
